"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableRestorePointsDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const Restore_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Restore/Restore.svg"));
const delete16_svg_1 = __importDefault(require("../../../assets/icons/delete16.svg"));
const export_svg_1 = __importDefault(require("../../../assets/icons/export.svg"));
const constants_1 = require("../../../constants");
const core_2 = require("../../../core");
const helpers_1 = require("./helpers");
const AvailableRestorePointsDataGridModel_1 = require("./AvailableRestorePointsDataGridModel");
const AvailableRestorePointsInteractor_1 = require("./AvailableRestorePointsInteractor");
const types_1 = require("./types");
const AvailableRestorePointsDialog = ({ dataGridLoader, onRestore, onRemove, onExport, onDeactivate, onCancel, onClose, texts, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = core_2.useFeatureContext();
    const [isLoading, loadingState] = react_1.useState(false);
    const [dataGridModel] = react_1.useState(() => {
        return new AvailableRestorePointsDataGridModel_1.AvailableRestorePointsDataGridModel(dataGridLoader)
            .withSorting({
            key: types_1.AvailableRestorePointsGridColumn.creationTimeUtc,
            direction: components_1.SORT_DIRECTION.desc,
        })
            .withPagination({
            offset: constants_1.GRID.initialOffset,
            limit: constants_1.GRID.pageLimit,
        });
    });
    const { interactor } = core_1.useInteractor(() => {
        const listeners = {
            onRestore,
            onRemove,
            onExport,
            onDeactivate,
            onCancel,
            onClose,
        };
        const presenters = {
            loadingState,
        };
        return new AvailableRestorePointsInteractor_1.AvailableRestorePointsInteractor(dataGridModel, listeners, presenters);
    });
    const columns = helpers_1.getColumns({
        instanceId: ((_a = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _a === void 0 ? void 0 : _a.instanceId) || t('availableRestorePointsDialog|grid|columns|instanceId|title'),
        size: ((_b = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _b === void 0 ? void 0 : _b.size) || t('availableRestorePointsDialog|grid|columns|size|title'),
        productVersion: ((_c = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _c === void 0 ? void 0 : _c.productVersion) ||
            t('availableRestorePointsDialog|grid|columns|productVersion|title'),
        creationTime: ((_d = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _d === void 0 ? void 0 : _d.creationTime) ||
            t('availableRestorePointsDialog|grid|columns|creationTime|title'),
        type: ((_e = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _e === void 0 ? void 0 : _e.type) || t('availableRestorePointsDialog|grid|columns|type|title'),
        manualType: ((_f = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _f === void 0 ? void 0 : _f.manualType) || t('availableRestorePointsDialog|grid|columns|type|manual'),
        scheduleType: ((_g = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _g === void 0 ? void 0 : _g.scheduleType) || t('availableRestorePointsDialog|grid|columns|type|schedule'),
    });
    return (react_1.default.createElement(components_1.Dialog, { id: "availableRestorePointsDialog", header: (texts === null || texts === void 0 ? void 0 : texts.header) || t('availableRestorePointsDialog|header'), hasTopPadding: false, loading: isLoading, size: {
            width: components_1.DIALOG_SIZE.xl,
            height: components_1.DIALOG_SIZE.xxl,
        }, onRequestClose: () => {
            interactor.onClose();
        }, actions: [
            {
                view: components_1.ACTION_VIEW.primary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonCancel) || t('availableRestorePointsDialog|actions|cancel|label'),
                onClick: () => {
                    interactor.onCancel();
                },
            },
        ] },
        react_1.default.createElement(components_1.DataGrid, { model: interactor.dataGridModel, columns: columns, toolbar: {
                items: [
                    components_1.toolbarAction({
                        id: 'restore',
                        icon: Restore_svg_1.default,
                        title: (texts === null || texts === void 0 ? void 0 : texts.buttonRestore) || t('availableRestorePointsDialog|actions|restore|label'),
                        decorators: [components_1.toolbarItemDecorators.disallowWithoutSingleSelection()],
                        handler: () => {
                            interactor.onRestore();
                        },
                    }),
                    components_1.toolbarAction({
                        id: 'remove',
                        icon: delete16_svg_1.default,
                        title: (texts === null || texts === void 0 ? void 0 : texts.buttonRemove) || t('availableRestorePointsDialog|actions|remove|label'),
                        decorators: [components_1.toolbarItemDecorators.disallowWithoutSingleSelection()],
                        handler: () => __awaiter(void 0, void 0, void 0, function* () {
                            yield interactor.onRemove();
                        }),
                    }),
                    components_1.toolbarAction({
                        id: 'export',
                        icon: export_svg_1.default,
                        title: (texts === null || texts === void 0 ? void 0 : texts.buttonExport) || t('availableRestorePointsDialog|actions|export|label'),
                        decorators: [components_1.toolbarItemDecorators.disallowWithoutSingleSelection()],
                        handler: () => {
                            interactor.onExport();
                        },
                    }),
                ],
            }, config: {
                autoLoad: true,
                canResizeColumns: true,
                columnsToggleable: false,
                selection: {
                    multi: false,
                },
            } })));
};
exports.AvailableRestorePointsDialog = AvailableRestorePointsDialog;
//# sourceMappingURL=AvailableRestorePointsDialog.js.map